import type { components } from '../api/shema';
import { useSeja } from './useSeja';

/** Paket naročnine (moduli instance, NACRT_DELAVNICA.md). */
export type Paket = NonNullable<components['schemas']['CenaPaketa']['paket']>;

/** Vsi paketi v vrstnem redu cenika (izbira v skrbništvu). */
export const PAKETI: Paket[] = ['PRODAJA', 'DELAVNICA', 'OBOJE'];

/** Ime paketa za uporabnike (kot {@code Paket.naziv} na strežniku). */
export const NAZIVI_PAKETOV: Record<Paket, string> = {
  PRODAJA: 'Prodaja vozil',
  DELAVNICA: 'Delavnica',
  OBOJE: 'Prodaja vozil in delavnica',
};

/** Kratek opis, kaj paket vsebuje (izbira pri registraciji in razširitev na zaslonu Naročnina). */
export const OPISI_PAKETOV: Record<Paket, string> = {
  PRODAJA: 'Zaloga vozil, računi in predračuni, pogodbe, javna ponudba vozil in povpraševanja.',
  DELAVNICA: 'Termini, stranke in njihova vozila, delovni nalogi, računi in predračuni.',
  OBOJE: 'Vse funkcije za prodajo vozil in za delavnico.',
};

/**
 * Paket iz parametra {@code ?paket=} (povezave s spletne strani, npr. {@code /registracija?paket=DELAVNICA}); velikost
 * črk in presledki niso pomembni, neznana vrednost je {@code null}.
 */
export function paketIzParametra(vrednost: string | null | undefined): Paket | null {
  const p = (vrednost ?? '').trim().toUpperCase();
  return (PAKETI as string[]).includes(p) ? (p as Paket) : null;
}

/** Ali paket vsebuje modul Prodaja; brez podatka (starejši strežnik) da. */
export function imaProdajo(paket: Paket | undefined): boolean {
  return paket !== 'DELAVNICA';
}

/** Ali paket vsebuje modul Delavnica; brez podatka (starejši strežnik) ne. */
export function imaDelavnico(paket: Paket | undefined): boolean {
  return paket === 'DELAVNICA' || paket === 'OBOJE';
}

/** Ali ima prijavljena instanca modul Delavnica (dokler seja ni naložena: ne). */
export function useDelavnica(): boolean {
  const stanje = useSeja();
  return stanje.status === 'prijavljen' && imaDelavnico(stanje.instanca.paket);
}

/** Ali ima prijavljena instanca modul Prodaja (dokler seja ni naložena: da). */
export function useProdaja(): boolean {
  const stanje = useSeja();
  return stanje.status !== 'prijavljen' || imaProdajo(stanje.instanca.paket);
}
